class PriceService {
  constructor() {
    // ✅ ALL SUPPORTED CRYPTOS
    this.cryptoSymbols = ['BTCUSD', 'ETHUSD', 'SOLUSD', 'XRPUSD', 'ADAUSD', 'DOGEUSD', 'AVAXUSD', 'LINKUSD', 'MATICUSD', 'DOTUSD'];
    
    this.prices = {
      XAUUSD: {
        price: 4215.00,
        change: 0,
        changePercent: 0,
        high: 4220.00,
        low: 4210.00,
        volume: '2.4M',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      // US Indices
      US30: {
        price: 45280.50,
        change: 185.20,
        changePercent: 0.41,
        high: 45350.00,
        low: 45150.00,
        volume: '890M',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      NAS100: {
        price: 21875.50,
        change: 125.30,
        changePercent: 0.57,
        high: 21920.00,
        low: 21820.00,
        volume: '5.8B',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      SPP500: {
        price: 6125.75,
        change: 28.50,
        changePercent: 0.47,
        high: 6145.00,
        low: 6105.00,
        volume: '3.2B',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      GER30: {
        price: 20875.30,
        change: -45.20,
        changePercent: -0.22,
        high: 20950.00,
        low: 20820.00,
        volume: '1.8B',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      // ✅ CRYPTOS
      BTCUSD: {
        price: 102450.00,
        change: 2150.00,
        changePercent: 2.15,
        high: 103200.00,
        low: 101800.00,
        volume: '18.2B',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      ETHUSD: {
        price: 3850.00,
        change: 85.00,
        changePercent: 2.26,
        high: 3920.00,
        low: 3780.00,
        volume: '8.5B',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      SOLUSD: {
        price: 185.50,
        change: 12.30,
        changePercent: 7.10,
        high: 192.00,
        low: 178.00,
        volume: '2.1B',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      XRPUSD: {
        price: 2.35,
        change: 0.18,
        changePercent: 8.29,
        high: 2.45,
        low: 2.20,
        volume: '4.2B',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      ADAUSD: {
        price: 1.05,
        change: 0.08,
        changePercent: 8.25,
        high: 1.12,
        low: 0.98,
        volume: '1.8B',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      DOGEUSD: {
        price: 0.42,
        change: 0.03,
        changePercent: 7.69,
        high: 0.45,
        low: 0.40,
        volume: '3.5B',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      AVAXUSD: {
        price: 45.80,
        change: 3.20,
        changePercent: 7.51,
        high: 48.50,
        low: 43.00,
        volume: '850M',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      LINKUSD: {
        price: 28.50,
        change: 2.10,
        changePercent: 7.95,
        high: 30.20,
        low: 27.00,
        volume: '620M',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      MATICUSD: {
        price: 0.95,
        change: 0.07,
        changePercent: 7.95,
        high: 1.02,
        low: 0.90,
        volume: '450M',
        lastUpdate: Date.now(),
        source: 'initializing'
      },
      DOTUSD: {
        price: 9.80,
        change: 0.65,
        changePercent: 7.10,
        high: 10.50,
        low: 9.20,
        volume: '380M',
        lastUpdate: Date.now(),
        source: 'initializing'
      }
    };

    // Previous prices for change calculation
    this.previousPrices = {};
    Object.keys(this.prices).forEach(symbol => {
      this.previousPrices[symbol] = null;
    });

    // Yahoo Finance symbols mapping
    this.yahooSymbols = {
      XAUUSD: 'GC=F',       // Gold Futures
      US30: 'YM=F',         // Dow Jones E-mini Futures
      NAS100: 'NQ=F',       // Nasdaq 100 E-mini Futures
      SPP500: 'ES=F',       // S&P 500 E-mini Futures
      GER30: '^GDAXI',      // DAX Index
      // Cryptos
      BTCUSD: 'BTC-USD',
      ETHUSD: 'ETH-USD',
      SOLUSD: 'SOL-USD',
      XRPUSD: 'XRP-USD',
      ADAUSD: 'ADA-USD',
      DOGEUSD: 'DOGE-USD',
      AVAXUSD: 'AVAX-USD',
      LINKUSD: 'LINK-USD',
      MATICUSD: 'MATIC-USD',
      DOTUSD: 'DOT-USD'
    };

    this.subscribers = new Map();
    this.updateInterval = null;
    this.isRunning = false;
    this.lastRealFetch = 0;
    this.realFetchInterval = 60000; // Fetch every 60 seconds (Twelve Data rate limit: 8/min)

    // Listen for TradingView price updates
    this.setupTradingViewListener();
    
    this.startRealTimeUpdates();
    console.log('📊 PriceService initialized - Twelve Data + Yahoo (Gold/Indices) + Binance (Crypto) - 60s refresh');
  }

  // ✅ LISTEN FOR TRADINGVIEW WIDGET PRICE UPDATES
  setupTradingViewListener() {
    window.addEventListener('tradingview-price-update', (event) => {
      if (event.detail && event.detail.price && event.detail.symbol) {
        const { price, symbol } = event.detail;
        console.log(`📊 TradingView price update: ${symbol} = $${price}`);

        if (symbol.includes('XAU') || symbol.includes('GOLD')) {
          this.updatePrice('XAUUSD', price, 'tradingview');
        } else if (symbol.includes('US30') || symbol.includes('YM')) {
          this.updatePrice('US30', price, 'tradingview');
        } else if (symbol.includes('NAS') || symbol.includes('NQ')) {
          this.updatePrice('NAS100', price, 'tradingview');
        } else if (symbol.includes('SPX') || symbol.includes('ES') || symbol.includes('SP500')) {
          this.updatePrice('SPP500', price, 'tradingview');
        } else if (symbol.includes('DAX') || symbol.includes('GER')) {
          this.updatePrice('GER30', price, 'tradingview');
        }
        // CRYPTO BRANCH — was missing, BTC stayed at seed $102,450 forever.
        // Now every TradingView crypto tick updates the live header price.
        else if (symbol.includes('BTC')) {
          this.updatePrice('BTCUSD', price, 'tradingview');
        } else if (symbol.includes('ETH')) {
          this.updatePrice('ETHUSD', price, 'tradingview');
        } else if (symbol.includes('SOL')) {
          this.updatePrice('SOLUSD', price, 'tradingview');
        } else if (symbol.includes('XRP')) {
          this.updatePrice('XRPUSD', price, 'tradingview');
        } else if (symbol.includes('ADA')) {
          this.updatePrice('ADAUSD', price, 'tradingview');
        } else if (symbol.includes('DOGE')) {
          this.updatePrice('DOGEUSD', price, 'tradingview');
        } else if (symbol.includes('AVAX')) {
          this.updatePrice('AVAXUSD', price, 'tradingview');
        } else if (symbol.includes('LINK')) {
          this.updatePrice('LINKUSD', price, 'tradingview');
        } else if (symbol.includes('MATIC')) {
          this.updatePrice('MATICUSD', price, 'tradingview');
        } else if (symbol.includes('DOT')) {
          this.updatePrice('DOTUSD', price, 'tradingview');
        }
      }
    });
  }

  // ✅ GENERIC UPDATE PRICE METHOD
  updatePrice(symbol, newPrice, source) {
    const now = Date.now();
    const oldPrice = this.previousPrices[symbol] || newPrice;
    const currentData = this.prices[symbol] || {};
    
    this.prices[symbol] = {
      price: parseFloat(newPrice.toFixed(2)),
      change: parseFloat((newPrice - oldPrice).toFixed(2)),
      changePercent: oldPrice > 0 ? parseFloat(((newPrice - oldPrice) / oldPrice * 100).toFixed(3)) : 0,
      high: Math.max(currentData.high || newPrice, newPrice),
      low: Math.min(currentData.low || newPrice, newPrice),
      volume: currentData.volume || 'N/A',
      lastUpdate: now,
      source: source
    };
    
    this.previousPrices[symbol] = newPrice;
    this.notifySubscribers();
  }

  // ✅ FETCH FROM YAHOO FINANCE FOR ANY SYMBOL
  async fetchFromYahooFinance(symbol, yahooTicker) {
    try {
      const response = await fetch(
        `https://query1.finance.yahoo.com/v8/finance/chart/${yahooTicker}?interval=1m&range=1d`,
        { 
          method: 'GET',
          headers: { 'Accept': 'application/json' }
        }
      );
      
      if (!response.ok) return null;
      
      const data = await response.json();
      const result = data?.chart?.result?.[0];
      const meta = result?.meta;
      
      if (meta?.regularMarketPrice) {
        const price = parseFloat(meta.regularMarketPrice);
        const previousClose = meta.chartPreviousClose || meta.previousClose || price;
        const change = price - previousClose;
        const changePercent = previousClose > 0 ? (change / previousClose) * 100 : 0;
        
        console.log(`✅ ${symbol} price from Yahoo Finance: $${price.toFixed(2)}`);
        return { 
          price, 
          previousClose,
          change,
          changePercent,
          high: meta.regularMarketDayHigh || price,
          low: meta.regularMarketDayLow || price,
          volume: this.formatVolume(meta.regularMarketVolume),
          source: 'yahoo-finance' 
        };
      }
    } catch (e) {
      console.warn(`Yahoo Finance API failed for ${symbol}:`, e.message);
    }
    return null;
  }

  // ✅ FETCH GOLD FROM METALS.LIVE (FALLBACK)
  async fetchFromMetalsAPI() {
    try {
      const response = await fetch('https://api.metals.live/v1/spot/gold', {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      });
      
      if (!response.ok) return null;
      
      const data = await response.json();
      if (data && data[0] && data[0].price) {
        console.log('✅ Gold price from Metals.live:', data[0].price);
        return { price: parseFloat(data[0].price), source: 'metals.live' };
      }
    } catch (e) {
      console.warn('Metals.live API failed');
    }
    return null;
  }

  // ✅ FORMAT VOLUME
  formatVolume(volume) {
    if (!volume) return 'N/A';
    if (volume >= 1e9) return `${(volume / 1e9).toFixed(1)}B`;
    if (volume >= 1e6) return `${(volume / 1e6).toFixed(1)}M`;
    if (volume >= 1e3) return `${(volume / 1e3).toFixed(1)}K`;
    return volume.toString();
  }

  startRealTimeUpdates() {
    if (this.isRunning) return;

    this.isRunning = true;
    this.updatePrices();
    
    this.updateInterval = setInterval(() => {
      this.updatePrices();
    }, 2000);

    console.log('🔄 Real-time price updates started');
  }

  async updatePrices() {
    const now = Date.now();

    // ✅ FETCH REAL PRICES PERIODICALLY
    if (now - this.lastRealFetch > this.realFetchInterval) {
      this.lastRealFetch = now;
      
      // Fetch all prices in parallel
      await this.fetchAllRealPrices();
    } else {
      // Micro-variations between fetches for smooth UI
      this.applyMicroVariations(now);
    }

    this.notifySubscribers();
  }

  // ✅ FETCH ALL REAL PRICES IN PARALLEL
  async fetchAllRealPrices() {
    // Fetch all crypto prices in ONE batched request
    await this.fetchAllCryptoPrices();
    
    // Fetch Gold from edge function
    const goldResult = await this.fetchGoldFromEdgeFunction() || await this.fetchFromMetalsAPI();
    if (goldResult && goldResult.price) {
      this.updatePriceData('XAUUSD', goldResult);
    }
    
    // Fetch indices from edge function (bypasses CORS)
    await this.fetchIndicesFromEdgeFunction();
  }

  // ✅ FETCH INDICES FROM EDGE FUNCTION
  async fetchIndicesFromEdgeFunction() {
    try {
      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
      const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
      
      const response = await fetch(
        `${supabaseUrl}/functions/v1/get-indices-prices`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${supabaseKey}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (!response.ok) {
        console.warn('Indices fetch failed:', response.status);
        return;
      }
      
      const data = await response.json();
      
      if (data.error || !data.prices) {
        console.warn('Indices fetch error:', data.error);
        return;
      }
      
      // Update all indices prices
      for (const [symbol, priceData] of Object.entries(data.prices)) {
        if (priceData && priceData.price) {
          this.updatePriceData(symbol, {
            price: parseFloat(priceData.price),
            change: priceData.change,
            changePercent: priceData.changePercent,
            high: priceData.high,
            low: priceData.low,
            volume: this.formatVolume(priceData.volume),
            source: 'twelve-data'
          });
        }
      }
      
      console.log(`✅ Fetched ${Object.keys(data.prices).length} indices from Twelve Data`);
    } catch (e) {
      console.warn('Indices edge function error:', e.message);
    }
  }

  // ✅ UPDATE PRICE DATA HELPER
  updatePriceData(symbol, result) {
    const currentData = this.prices[symbol] || {};
    const oldPrice = this.previousPrices[symbol] || result.price;
    
    this.prices[symbol] = {
      price: parseFloat(result.price.toFixed(2)),
      change: result.change !== undefined 
        ? parseFloat(result.change.toFixed(2)) 
        : parseFloat((result.price - oldPrice).toFixed(2)),
      changePercent: result.changePercent !== undefined 
        ? parseFloat(result.changePercent.toFixed(3)) 
        : (oldPrice > 0 ? parseFloat(((result.price - oldPrice) / oldPrice * 100).toFixed(3)) : 0),
      high: result.high || Math.max(currentData.high || result.price, result.price),
      low: result.low || Math.min(currentData.low || result.price, result.price),
      volume: result.volume || currentData.volume || 'N/A',
      lastUpdate: Date.now(),
      source: result.source
    };
    
    this.previousPrices[symbol] = result.price;
    console.log(`✅ ${symbol}: $${result.price.toFixed(2)} (${result.source})`);
  }

  // ✅ FETCH ALL CRYPTO PRICES IN ONE BATCHED REQUEST
  // Flag to prevent concurrent requests
  _cryptoFetchInProgress = false;
  
  async fetchAllCryptoPrices() {
    // Prevent duplicate concurrent requests
    if (this._cryptoFetchInProgress) {
      console.log('⏳ Crypto fetch already in progress, skipping...');
      return;
    }
    
    this._cryptoFetchInProgress = true;
    
    try {
      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
      const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
      const cryptoSymbols = this.cryptoSymbols.map(s => s.replace('USD', '')).join(',');
      
      const response = await fetch(
        `${supabaseUrl}/functions/v1/get-crypto-prices?symbols=${cryptoSymbols}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${supabaseKey}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (!response.ok) {
        console.warn('Crypto batch fetch failed:', response.status);
        return;
      }
      
      const data = await response.json();
      
      if (data.error || !data.prices) {
        console.warn('Crypto batch error:', data.error);
        return;
      }
      
      // Update all crypto prices from batched response
      for (const [symbol, priceData] of Object.entries(data.prices)) {
        const fullSymbol = `${symbol}USD`;
        if (priceData && priceData.price) {
          this.updatePriceData(fullSymbol, {
            price: parseFloat(priceData.price),
            changePercent: priceData.change24h || 0,
            volume: this.formatVolume(priceData.volume),
            source: data.source || 'coingecko'
          });
        }
      }
      
      console.log(`✅ Fetched ${Object.keys(data.prices).length} crypto prices in one request`);
    } catch (e) {
      console.warn('Crypto batch fetch error:', e.message);
    } finally {
      this._cryptoFetchInProgress = false;
    }
  }

  // ✅ FETCH GOLD FROM EDGE FUNCTION (YAHOO FINANCE)
  async fetchGoldFromEdgeFunction() {
    try {
      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
      const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
      
      const response = await fetch(
        `${supabaseUrl}/functions/v1/get-gold-price`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${supabaseKey}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (!response.ok) return null;
      
      const data = await response.json();
      
      if (data.error || data.fallback) return null;
      
      if (data.price) {
        console.log(`✅ Gold from Edge Function: $${data.price} (${data.source})`);
        return { 
          price: parseFloat(data.price),
          change: data.change,
          changePercent: data.changePercent,
          high: data.high,
          low: data.low,
          source: data.source || 'yahoo-finance' 
        };
      }
    } catch (e) {
      console.warn('Edge function error for Gold:', e.message);
    }
    return null;
  }

  // ✅ APPLY MICRO-VARIATIONS FOR SMOOTH UI
  applyMicroVariations(now) {
    const variations = {
      XAUUSD: { range: 0.3 },
      US30: { range: 5 },
      NAS100: { range: 3 },
      SPP500: { range: 1 },
      GER30: { range: 2 },
      // Cryptos have higher volatility
      BTCUSD: { range: 50 },
      ETHUSD: { range: 5 },
      SOLUSD: { range: 0.5 },
      XRPUSD: { range: 0.01 },
      ADAUSD: { range: 0.005 },
      DOGEUSD: { range: 0.002 },
      AVAXUSD: { range: 0.3 },
      LINKUSD: { range: 0.15 },
      MATICUSD: { range: 0.005 },
      DOTUSD: { range: 0.05 }
    };

    Object.keys(this.prices).forEach(symbol => {
      const prevPrice = this.previousPrices[symbol];
      const varConfig = variations[symbol];
      if (prevPrice && varConfig) {
        const microVariation = (Math.random() - 0.5) * varConfig.range;
        const displayPrice = prevPrice + microVariation;
        
        this.prices[symbol] = {
          ...this.prices[symbol],
          price: parseFloat(displayPrice.toFixed(symbol.includes('USD') && ['DOGE', 'ADA', 'MATIC', 'XRP'].some(c => symbol.includes(c)) ? 4 : 2)),
          lastUpdate: now
        };
      }
    });
  }

  getCurrentPrice(symbol = 'XAUUSD') {
    const priceData = this.prices[symbol];
    
    if (!priceData) {
      return this.prices.XAUUSD;
    }

    return {
      ...priceData,
      symbol,
      timestamp: new Date().toISOString()
    };
  }

  getAllPrices() {
    return Object.keys(this.prices).reduce((result, symbol) => {
      result[symbol] = this.getCurrentPrice(symbol);
      return result;
    }, {});
  }

  subscribe(callback, symbols = ['XAUUSD']) {
    const subscriberId = Date.now() + Math.random();
    
    this.subscribers.set(subscriberId, {
      callback,
      symbols: Array.isArray(symbols) ? symbols : [symbols],
      lastNotified: 0
    });

    setTimeout(() => {
      const data = {};
      symbols.forEach(symbol => {
        data[symbol] = this.getCurrentPrice(symbol);
      });
      callback(data);
    }, 100);

    return subscriberId;
  }

  unsubscribe(subscriberId) {
    return this.subscribers.delete(subscriberId);
  }

  notifySubscribers() {
    const now = Date.now();
    
    this.subscribers.forEach((subscriber, id) => {
      if (now - subscriber.lastNotified < 1000) return;

      try {
        const data = {};
        subscriber.symbols.forEach(symbol => {
          data[symbol] = this.getCurrentPrice(symbol);
        });
        subscriber.callback(data);
        subscriber.lastNotified = now;
      } catch (error) {
        this.subscribers.delete(id);
      }
    });
  }

  // ✅ ALLOW MANUAL PRICE UPDATE
  setPrice(symbol, price) {
    if (price && price > 0) {
      this.updatePrice(symbol, price, 'manual');
    }
  }

  // Legacy method for backward compatibility
  setGoldPrice(price) {
    this.setPrice('XAUUSD', price);
  }

  getMarketStatus() {
    const now = new Date();
    const utcHour = now.getUTCHours();
    const day = now.getUTCDay();
    
    // Weekend check
    if (day === 0 || day === 6) {
      return {
        currentSession: 'Weekend',
        isMarketOpen: false,
        utcTime: now.toISOString()
      };
    }
    
    let session = 'Closed';
    if (utcHour >= 0 && utcHour < 9) session = 'Asia';
    else if (utcHour >= 8 && utcHour < 17) session = 'London';
    else if (utcHour >= 13 && utcHour < 22) session = 'New York';
    else session = 'After Hours';
    
    return {
      currentSession: session,
      isMarketOpen: ['Asia', 'London', 'New York'].includes(session),
      utcTime: now.toISOString()
    };
  }

  // ✅ GET MARKET STATUS FOR SPECIFIC ASSET
  getAssetMarketStatus(symbol) {
    const now = new Date();
    const utcHour = now.getUTCHours();
    const day = now.getUTCDay();
    
    // Weekend - most markets closed
    if (day === 0 || day === 6) {
      // Crypto trades 24/7
      if (symbol === 'BTCUSD') {
        return { isOpen: true, session: 'Crypto 24/7' };
      }
      return { isOpen: false, session: 'Weekend' };
    }
    
    // US Indices (US30, NAS100, SPP500) - 14:30 to 21:00 UTC
    if (['US30', 'NAS100', 'SPP500'].includes(symbol)) {
      const isOpen = utcHour >= 14 && utcHour < 21;
      return { 
        isOpen, 
        session: isOpen ? 'US Session' : 'Closed',
        openTime: '14:30 UTC',
        closeTime: '21:00 UTC'
      };
    }
    
    // European Indices (GER30) - 07:00 to 21:00 UTC
    if (symbol === 'GER30') {
      const isOpen = utcHour >= 7 && utcHour < 21;
      return { 
        isOpen, 
        session: isOpen ? 'European Session' : 'Closed',
        openTime: '07:00 UTC',
        closeTime: '21:00 UTC'
      };
    }
    
    // Gold (XAUUSD) - Almost 24h (22:00 Sun - 21:00 Fri UTC)
    if (symbol === 'XAUUSD') {
      return { isOpen: true, session: 'Forex/Commodities' };
    }
    
    // All Cryptos - 24/7
    if (this.cryptoSymbols.includes(symbol)) {
      return { isOpen: true, session: 'Crypto 24/7' };
    }
    
    return { isOpen: false, session: 'Unknown' };
  }

  // ✅ GET ALL CRYPTO SYMBOLS
  getCryptoSymbols() {
    return this.cryptoSymbols;
  }

  stop() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
      this.updateInterval = null;
    }
    this.isRunning = false;
  }

  restart() {
    this.stop();
    setTimeout(() => this.startRealTimeUpdates(), 1000);
  }
}

const priceService = new PriceService();
export default priceService;
